<template>
  <div class="order-export-button">
    <v-btn
      color="blue darken-2"
      outlined
      @click="showDialogOrderExportSettings = true"
      v-tooltip="getTooltipHtml()"
      >Export to CSV</v-btn
    >
    <DialogOrderExportSettings />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

import DialogOrderExportSettings from '@/components/DialogOrderExportSettings'

export default {
  name: 'AdminOrderCSVexportButton',
  components: { DialogOrderExportSettings },
  data() {
    return {}
  },
  computed: {
    ...mapFields('admin', ['showDialogOrderExportSettings']),
  },
  methods: {
    getTooltipHtml() {
      const text = `Export to a spreadsheet,<br/> limited to 200 records.<br/>Contact us for a full export.`
      return {
        content: `<div class='proxima--font'>${text}</div>`,
        html: true,
        placement: 'bottom',
      }
    },
  },
}
</script>
